module.exports = __webpack_public_path__ + "images/c3cd46709c53cab244df8accf6418b37.svg";